import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private isDevelopment(): boolean {
    return !environment.production;
  }

  /**
   * Log de erro - só aparece em desenvolvimento
   */
  error(message: string, data?: any): void {
    if (this.isDevelopment()) {
      console.error(message, data);
    }
    // Em produção: silencioso ou pode enviar para serviço de monitoramento
  }

  /**
   * Log de aviso - só aparece em desenvolvimento
   */
  warn(message: string, data?: any): void {
    if (this.isDevelopment()) {
      console.warn(message, data);
    }
  }

  /**
   * Log de informação - só aparece em desenvolvimento
   */
  info(message: string, data?: any): void {
    if (this.isDevelopment()) {
      console.log(message, data);
    }
  }

  /**
   * Log de debug - só aparece em desenvolvimento
   */
  debug(message: string, data?: any): void {
    if (this.isDevelopment()) {
      console.debug(message, data);
    }
  }

  /**
   * Verifica se está em modo desenvolvimento
   */
  isDevMode(): boolean {
    return this.isDevelopment();
  }
}
